import { Grid } from "@material-ui/core";
import { Switch, Route, Redirect } from "react-router-dom";

// Components
import Login from "./authentication/login/Login";
import ForgotPassword from "./authentication/forgotPassword/ForgotPassword";
import AssessmentForm from "./assessmentForm/AssessmentForm";
import Assessment from "./assessmentForm/Assessment";
import AssessmentResults from "./assessmentResult/AssessmentResults";

const MainContainer = () => {
	return (
		<Grid className="w-100">
			<Switch>
				<Route path="/questionnaire/login" component={Login} />
				<Route path="/questionnaire/assessment_form" component={AssessmentForm} />
				<Route path="/questionnaire/assessment_result" component={AssessmentResults} />
				<Route path="/questionnaire/assessment" component={Assessment} />
				<Route path="/questionnaire/result" component={ForgotPassword} />
				<Route path="/questionnaire/">
					<Redirect to="/questionnaire/assessment" />
				</Route>
			</Switch>
		</Grid>
	);
};

export default MainContainer;
